<div class="report-root">
  <section class="report-card report-header-panel">
    <div class="report-title-row">
      <h6 class="HeadContent mb-0 report-title">Validate External references in Flashcard</h6>
    </div>

    <div class="report-controls-grid">
      <div class="report-control-item">
        <label for="searchString" class="report-filter-label">Search String</label>
        <input
          id="searchString"
          type="text"
          class="form-control form-control-sm report-filter-control"
          [value]="searchString"
          readonly
          disabled
        />
      </div>

      <div class="report-control-item">
        <label for="stringToExclude" class="report-filter-label">String To Exclude</label>
        <input
          id="stringToExclude"
          type="text"
          class="form-control form-control-sm report-filter-control"
          [value]="stringToExclude"
          readonly
          disabled
        />
      </div>

      <div class="report-action-item">
        <div class="d-flex gap-2">
          <button
            class="btn btn-sm bl-btn report-filter-btn"
            type="button"
            (click)="fetchReport()"
            [disabled]="isLoading"
          >
            {{ isLoading ? "Loading..." : "Search" }}
          </button>
          <button
            class="btn btn-sm btn-outline-secondary report-filter-btn"
            type="button"
            (click)="clearFilters()"
            [disabled]="true"
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="report-card report-table-card">
    <div class="table-responsive report-table-wrapper">
      <table class="table table-striped table-bordered table-sm">
        <thead>
          <tr class="table-secondary">
            <th class="text-center">Flashcard ID</th>
            <th class="text-center">Side</th>
            <th class="text-center">Created By</th>
            <th class="text-center">Src Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of reportRows">
            <td>
              <a
                href=""
                class="report-question-link"
                (click)="openFlashcardEditor(row, $event)"
              >
                {{ row.Flashcard_ID }}
              </a>
            </td>
            <td>{{ row.Side }}</td>
            <td>{{ row.Created_By }}</td>
            <td>
              <a [href]="row.SrcValue" target="_blank" rel="noopener noreferrer" class="report-question-link">
                {{ row.SrcValue }}
              </a>
            </td>
          </tr>
          <tr *ngIf="!isLoading && reportRows.length === 0">
            <td colspan="4" class="text-center">No records found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>

<div *ngIf="showFlashcardEditor" class="flashcard-editor-wrapper" (click)="closeEventTrigger()">
  <div class="flashcard-editor-content" (click)="$event.stopPropagation()">
    <button
      type="button"
      class="flashcard-editor-close-btn"
      (click)="closeEventTrigger()"
      aria-label="Close"
    >
      ×
    </button>
    <app-fa-question-add-edit
      #flashcardEditorHost
      [subjectById]="editorSubjectById"
      [flashCardId]="flashCardId"
      [globalFlashCardList]="globalFlashCardList"
      [closeEventTriggerFa]="closeTriggerValue"
      (closeFaDialog)="closeFaDialog($event)"
    ></app-fa-question-add-edit>
  </div>
</div>
